window.ratioCalculator = (() => {
    const myObj = {
        settings: {},
        resultsHtml: "",
        calculatorResult: "",
        init: function (settings) {
            //copy passed in settings
            this.settings = settings;
            //copy the original results html to reuse on click
            this.resultsHtml = $(".calculatorResultArea").html();
            this.calculatorResult = $("#calculatorResult");
            //add click event to submit button
            $("#btnSubmitCalculator").on("click", this.displayErrors);
        },
        displayErrors: function () {
            //create arrays holding all values
            const values = [];
            //gets input values
            $(".ratio-calculator input[type='text']").each(function () {
                values.push(($(this).val()));
            });
            //checks if values are valid
            const isValueValid = [];
            let i = 0;
            while (i < values.length) {
                isValueValid.push(this.validate(values[i]));
                i++;
            }
            //checks if form has errors and sends or displays errors.
            let noErrorsFound = true;
            i = 0;
            while (noErrorsFound && i < isValueValid.length) {
                noErrorsFound = isValueValid[i].valid;
                i++;
            }
            //remove error messages class colors
            $(".ratio-calculator .form-group").removeClass("errorMessage");
            $(".ratio-calculator .form-group label").find("div").remove();
            //if no errors found send form
            if (noErrorsFound) {
                this.calculate(values);
            }
            else {
                //cycles through values and show error messages
                for (i = 0; i < isValueValid.length; i++) {
                    const currentIndex = String(i + 1);
                    if (!isValueValid[i].valid) {
                        $(`#label${currentIndex}`).addClass("errorMessage");
                        $(`#label${currentIndex} label`).append($("<div/>", {
                            text: String(`${isValueValid[i].error}`)
                        }));
                    }
                }
                this.calculatorResult.css("display", "none");
            }
        },
        validate: function (fieldValue) {
            //construct an error object to hold valid switch and associated error message
            const errorObj = {
                "valid": false,
                "error": ""
            };
            //if field value is defined then validate
            if (typeof fieldValue != "undefined") {
                //check if not a number or has a decimal
                if (isNaN(Number(fieldValue)) || Number(fieldValue) % 1 !== 0 || fieldValue.trim() === "") {
                    errorObj.error = this.settings.errors.isnan;
                }
                //check if less than zero
                else if (Number(fieldValue) <= 0) {
                    errorObj.error = this.settings.errors.belowzero;
                }
                else {
                    errorObj.valid = true;
                }
            }
            return errorObj;
        },
        successAjax: function (response) {
            //replace required value in text area with the appropriate result
            let text = this.resultsHtml;
            text = String(text).replaceAll(/\{\{Result\}\}/ig, response.result);
            //clobber existing html with adjusted html
            $(".calculatorResultArea").html(text);
            this.calculatorResult.css("display", "block");
        },
        calculate: function (values) {
            //construct a data object from available fields.
            const sendingValues = {};
            for (let i = 0, y = 1; i < values.length; i++, y++) {
                sendingValues[`FieldValue${String(y)}`] = values[i];
            }
            //build ajax parameters object
            const ajaxParams = {
                type: "POST",
                url: this.settings.url,
                data: JSON.stringify(sendingValues),
                contentType: "application/json",
                dataType: "json",
                success: this.successAjax,
                error(response) {
                    alert(response.d);
                }
            };
            $.ajax(ajaxParams);
        }
    };
    myObj.init = myObj.init.bind(myObj);
    myObj.displayErrors = myObj.displayErrors.bind(myObj);
    myObj.calculate = myObj.calculate.bind(myObj);
    myObj.validate = myObj.validate.bind(myObj);
    myObj.successAjax = myObj.successAjax.bind(myObj);
    return myObj;
})();
// function hello(compiler: string) {
//     console.log(`Hello and Welcome ${compiler}`);
// }
// hello('TypeScript');
